module.exports = __webpack_public_path__ + "img/icon_config.44b24c2d.png";